import type { LocationPublicGetResponse } from '@govinity/validation/public';

import { ReadOnlyApi } from '../base';

/**
 * Read-only client for a government's public locations. Used by the live display app to resolve a
 * location by id and discover whether it currently has a live meeting.
 */
export class LocationsApi extends ReadOnlyApi<
  LocationPublicGetResponse,
  LocationPublicGetResponse
> {
  parentPath: string;
  governmentCode: string;

  constructor(governmentCode: string, parentPath: string) {
    super();

    this.parentPath = parentPath;
    this.governmentCode = governmentCode;
  }

  getPath() {
    return `${this.parentPath}/${this.governmentCode}/locations`;
  }
}
